<template>
  <div class="container-lotes-tabela">
    <div v-if="itens.length <= 0" class="container-lotes-no-data">
      <h2>Não foram encontrados registros!</h2>
    </div>
    <az-container v-else>
      <az-form>
        <v-data-table :headers="colunas" :items="itens" :total-items="totalItens"
                      :pagination.sync="paginacaoInterna" :loading="false"
                      hide-actions
                      class="az-table-list table-lotes-pagina-interna">
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{ props.item.descricao }}</td>
              <td>{{ props.item.codigo }}</td>
              <td>{{ props.item.fase | azEnum(faseLote) }}</td>
              <td>{{ props.item.situacao | azEnum(situacaoLote) }}</td>
              <td>{{ props.item.melhorLance | valorParaReal}}</td>
            </tr>
          </template>
        </v-data-table>
      </az-form>
    </az-container>
    <div class="az-pagination">
      <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
      <div class="az-select-pagination">
        <span>Linhas por página:</span>
        <v-select :items="linhasPorPagina" v-model="paginacaoInterna.size"/>
      </div>
    </div>
  </div>
</template>

<script>

import {statusLicitacao, situacaoLote, faseLote} from '@/core/constants'

export default {
  name: 'PaginaInternaLicitacaoLotesTabela',
  props: ['itens', 'paginacao', 'paginas', 'totalItens'],
  data() {
    return {
      paginacaoInterna: this.paginacao,
      linhasPorPagina: [10, 25, 50, 100],
      colunas: [
        {
          value: 'descricao',
          text: 'Tipo',
          align: 'left',
          width: '40px',
          sortable: false,
          class: 'primary--text'
        },
        {
          value: 'codigo',
          text: 'Item',
          align: 'left',
          width: '60px',
          sortable: false,
          class: 'primary--text'
        },
        {
          value: 'fase',
          text: 'Fase',
          align: 'left',
          width: '100px',
          sortable: false,
          class: 'primary--text'
        },
        {
          value: 'situacao',
          text: 'Situação',
          align: 'left',
          width: '50px',
          sortable: false,
          class: 'primary--text'
        },
        {
          value: 'melhorLance',
          text: 'Melhor Lance',
          align: 'left',
          width: '50px',
          sortable: false,
          class: 'primary--text'
        },
      ],
      statusLicitacao,
      situacaoLote,
      faseLote
    }
  },
  watch: {
    paginacaoInterna: {
      handler(novoValor) {
        this.$emit('paginar', novoValor)
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="stylus">

.container-lotes-tabela
  padding 10px 10%

.container-lotes-no-data
  height 20em
  display flex
  flex-direction column
  justify-content center
  align-items center
  color #A8A8A8

@media (max-width 720px)
  .table-lotes-pagina-interna
    td:nth-of-type(1):before
      content "Lote:"

    td:nth-of-type(2):before
      content "Item:"

    td:nth-of-type(2):before
      content "Fase:"

    td:nth-of-type(3):before
      content "Situação:"

    td:nth-of-type(5):before
      content "Melhor Lance:"


@media (max-width 500px)
  .az-container
    margin-bottom 0

</style>